var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("echarts 中国-3D 地图")]),_c('div',{ref:"myEchart",attrs:{"id":"personnel"}})])}
var staticRenderFns = []

export { render, staticRenderFns }